// extracted by mini-css-extract-plugin
export default {"wrapper":"Partners_wrapper__bLCQM","title":"Partners_title__0mbvw","text":"Partners_text__ok8Zo","content":"Partners_content__nTp32"};